function isFullscreen(): boolean {
  return (
    (window as { fullScreen?: boolean }).fullScreen
    || (window.innerWidth === screen.width && window.innerHeight === screen.height)
  );
}

export default isFullscreen;
